import React from 'react';

const SupportPage = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white p-8">
      <div className=" mx-auto">
        
        <div className="bg-slate-800 rounded-lg p-8 border border-slate-700 max-w-2xl">
          <div className="flex items-center mb-6">
            <div className="bg-blue-600 p-3 rounded-lg mr-4">
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
            </div>
            <h2 className="text-2xl font-semibold text-white">Contact Us</h2>
          </div>
          
          <p className="text-slate-300 text-lg mb-6 leading-relaxed">
            For technical support, billing inquiries, or general assistance, please reach out to our support team:
          </p>
          
          <div className="bg-slate-700 rounded-lg p-6 border border-slate-600">
            <p className="text-slate-400 text-sm uppercase tracking-wide mb-2">Email Support</p>
            <a 
              href="mailto:info@qurve.ai"
              className="text-2xl font-medium text-blue-400 hover:text-blue-300 transition-colors duration-200 block"
            >
              info@qurve.ai
            </a>
          </div>
          
          <p className="text-slate-400 text-sm mt-4">
            We typically respond within 24 hours during business days.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SupportPage;
